import { render } from "./DesignerSettings.vue?vue&type=template&id=250b9c7a"
import script from "./DesignerSettings.vue?vue&type=script&lang=js"
export * from "./DesignerSettings.vue?vue&type=script&lang=js"
script.render = render

export default script